import { render, staticRenderFns } from "./DetailsCard.vue?vue&type=template&id=18db3df2&scoped=true&"
import script from "./DetailsCard.vue?vue&type=script&lang=ts&"
export * from "./DetailsCard.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsCard.vue?vue&type=style&index=0&id=18db3df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db3df2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardTitle,VContainer,VDivider})
